/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Icon from '../../../../../../components/Icon';

import { changeStep } from '../../../../../../redux/new-schedule';

import './styles.css';

class SideMenu extends Component {
  componentWillReceiveProps = nextProps => {
    if (this.props.currentStep !== nextProps.currentStep) {
      this._validRoute(nextProps.currentStep);
    }
  };

  componentDidMount = () => {
    this._validRoute(this.props.currentStep);
  };

  _validRoute = step => {
    const { history, match, currentType } = this.props;
    if (!this._matchRoute(step)) {
      switch (step) {
        case 1:
          history.push(
            `${match.url.replace(`/${match.url.split('/').reverse()[0]}`, '')}`,
          );
          break;
        case 2:
          history.push(
            `${match.url.replace(
              `/${match.url.split('/').reverse()[0]}`,
              currentType === 0 ? '/carga' : '/descarga',
            )}`,
          );
          break;
        case 3:
          history.push(
            `${match.url.replace(
              `/${match.url.split('/').reverse()[0]}`,
              '/motoristas',
            )}`,
          );
          break;
        case 4:
          history.push(
            `${match.url.replace(
              `/${match.url.split('/').reverse()[0]}`,
              '/calendario',
            )}`,
          );
          break;
      }
    }
  };

  _matchRoute = step => {
    switch (step) {
      case 1:
        return (
          this.props.match.url.indexOf('carga') === -1 &&
          this.props.match.url.indexOf('motorista') === -1 &&
          this.props.match.url.indexOf('calendario') === -1
        );
      case 2:
        return (
          this.props.match.url.indexOf('carga') !== -1 ||
          this.props.match.url.indexOf('descarga') !== -1
        );
      case 3:
        return this.props.match.url.indexOf('motorista') !== -1;
      case 4:
        return this.props.match.url.indexOf('calendario') !== -1;
    }
  };

  _renderIconClass = step => {
    if (this.props.currentStep === step) {
      return 'SideMenu__icon--active';
    }
    if (this.props.currentStep > step) {
      return 'SideMenu__icon--completed';
    }
    if (step <= this.props.availableStep) {
      return 'SideMenu__icon--available';
    }
    return 'SideMenu__icon--disable';
  };

  _renderIcon = step => {
    if (this.props.currentStep > step) {
      return 'check_circle_checked';
    }
    return 'radio_button_unchecked';
  };

  render() {
    const { availableStep } = this.props;
    return (
      <div className="SideMenu">
        <div
          className={`SideMenu__icon ${this._renderIconClass(1)}`}
          onClick={() => {
            availableStep >= 1 ? this.props.dispatch(changeStep(1)) : {};
          }}
        >
          <Icon name={this._renderIcon(1)} /> <span>1. Tipo</span>
        </div>
        <div
          className={`SideMenu__icon ${this._renderIconClass(2)}`}
          onClick={() => {
            availableStep >= 2 ? this.props.dispatch(changeStep(2)) : {};
          }}
        >
          <Icon name={this._renderIcon(2)} /> <span>2. Notas Fiscais</span>
        </div>
        <div
          className={`SideMenu__icon ${this._renderIconClass(3)}`}
          onClick={() => {
            availableStep >= 3 ? this.props.dispatch(changeStep(3)) : {};
          }}
        >
          <Icon name={this._renderIcon(3)} />{' '}
          <span>3. Motorista e Veículos</span>
        </div>
        <div
          className={`SideMenu__icon ${this._renderIconClass(4)}`}
          onClick={() => {
            availableStep >= 4 ? this.props.dispatch(changeStep(4)) : {};
          }}
        >
          <Icon name={this._renderIcon(4)} /> <span>4. Calendário</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.newSchedule.currentStep,
  currentType: state.newSchedule.currentType,
  availableStep: state.newSchedule.availableStep,
});

export default connect(mapStateToProps)(SideMenu);
